export default __webpack_public_path__ + "static/web202302-20c9fab4f8bc91ad3de065a363d54327.png";